import React from 'react'
import PropTypes from 'prop-types'

import IntegrationAuthenticationSegment from 'components/IntegrationAuthenticationSegment'
import { RenderModal } from 'components/RenderModal'
import { InfusionsoftAuthenticationModal } from 'components/InfusionsoftAuthenticationModal'
import { CustomerSyncExplanation } from 'components/CustomerSyncExplanation'
import { ToggleCustomerSyncButton } from 'components/ToggleCustomerSyncButton'

export const InfusionsoftIntegration = ({
  syncButtonLoading,
  authenticationLoading,
  isAuthenticated,
  isCredentialError,
  isCustomersSyncEnabled,
  createOnSubmit,
  revokeAccess,
  toggleCustomersSync,
}) => (
  <React.Fragment>
    <div className="admin-heading">
      <h2>Infusionsoft Contact Sync</h2>
    </div>
    <div className="ui stackable grid">
      <div className="twelve wide column">
        <CustomerSyncExplanation
          integration="Infusionsoft"
          helpCenterLink="https://help.simplesat.io/integrations/infusionsoft/importing-and-syncing-infusionsoft-contacts"
        />
        <ToggleCustomerSyncButton
          isAuthenticated={isAuthenticated}
          syncButtonLoading={syncButtonLoading}
          isCustomersSyncEnabled={isCustomersSyncEnabled}
          toggleCustomersSync={toggleCustomersSync}
          syncLabel="Customer Sync"
        />
        <hr />
        <RenderModal>
          {({ Modal, open, close }) => (
            <React.Fragment>
              <IntegrationAuthenticationSegment
                isAuthenticated={isAuthenticated}
                loading={authenticationLoading}
                name="Infusionsoft"
                onActivate={open}
                onDeactivate={revokeAccess}
              />
              <Modal size="small">
                <InfusionsoftAuthenticationModal
                  isCredentialError={isCredentialError}
                  loading={authenticationLoading}
                  handleClose={close}
                  onSubmit={createOnSubmit(close)}
                />
              </Modal>
            </React.Fragment>
          )}
        </RenderModal>
      </div>
    </div>
  </React.Fragment>
)

InfusionsoftIntegration.propTypes = {
  syncButtonLoading: PropTypes.bool,
  authenticationLoading: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  isCredentialError: PropTypes.bool,
  isCustomersSyncEnabled: PropTypes.bool,
  createOnSubmit: PropTypes.func.isRequired,
  revokeAccess: PropTypes.func.isRequired,
  toggleCustomersSync: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/InfusionsoftIntegration/index.js